import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getMySkills = () => {
  return base.get({
    url: API_PARAM.DASHBOARD_MY_SKILLS,
  });
};

export const getJobsOfInterest = () => {
  return base.get({
    url: API_PARAM.DASHBOARD_JOBS_OF_INTEREST,
  });
};

export const getTimeInvestment = () => {
  return base.get({
    url: API_PARAM.DASHBOARD_TIME_INVESTMENT,
  });
};
